export default __webpack_public_path__ + "579663b5a86d5f4d91535d0aa3d09e46.png";